import root from 'window-or-global'

import {
  GOOGLE_SCRIPT_SRC,
  FACEBOOK_SCRIPT_SRC,
  APPLE_SCRIPT_SRC
} from './constants'
import {
  shouldInitGoogle,
  shouldInitFacebook,
  shouldInitApple
} from './helpers'

const scripts = {
  google: {
    loaded: false,
    src: GOOGLE_SCRIPT_SRC
  },

  facebook: {
    loaded: false,
    src: FACEBOOK_SCRIPT_SRC
  },

  apple: {
    loaded: false,
    src: APPLE_SCRIPT_SRC
  }
}

class SSOScriptsLoader {
  constructor() {
    this.loadScript('google')
    this.loadScript('facebook')
    this.shouldLoadAppleScript()
  }

  hasFacebookScriptLoaded(type) {
    return this.hasScriptLoaded('facebook')
  }

  hasGoogleScriptLoaded(type) {
    return this.hasScriptLoaded('google')
  }

  hasAppleScriptLoaded(type) {
    return this.hasScriptLoaded('apple')
  }

  hasScriptLoaded(type) {
    return scripts[type].loaded
  }

  fbEnsureInit(callback) {
    let timeout
    if (!root.fbAPIInit) {
      timeout = setTimeout(() => this.fbEnsureInit(callback), 50)
    } else {
      clearTimeout(timeout)
      callback()
    }
  }

  ensureGoogleInit(callback) {
    let timeout

    if (!root.google) {
      timeout = setTimeout(() => this.ensureGoogleInit(callback), 50)
    } else {
      clearTimeout(timeout)
      callback()
    }
  }

  setLoadState(type, value) {
    scripts[type].loaded = value
  }

  initGoogle(type) {
    if (shouldInitGoogle(type)) {
      return this.ensureGoogleInit(this.setLoadState.bind(this, type, true))
    }
  }

  initFacebook(type) {
    if (shouldInitFacebook(type)) {
      return this.fbEnsureInit(this.setLoadState.bind(this, type, true))
    }
  }

  initApple(type) {
    if (shouldInitApple(type)) {
      return this.ensureAppleInit(this.setLoadState.bind(this, type, true))
    }
  }

  initScript(type) {
    this.initGoogle(type)
    this.initFacebook(type)
    this.initApple(type)
  }

  ensureAppleInit(callback) {
    let timeout
    if (!root.AppleID) {
      timeout = setTimeout(() => this.ensureAppleInit(callback), 50)
    } else {
      clearTimeout(timeout)
      callback()
    }
  }

  loadScript(type) {
    if (!scripts[type]) return null

    if (!scripts[type].loaded) {
      const script = root.document.createElement('script')
      script.async = 'async'
      script.src = scripts[type].src

      root.document.getElementsByTagName('head')[0].appendChild(script)
      script.onload = this.initScript.bind(this, type)

      return script
    }
  }

  shouldLoadAppleScript() {
    if (!process.env.APPLE_SSO_ENABLED) return null

    return this.loadScript('apple')
  }
}

const scriptLoader = new SSOScriptsLoader()

export default scriptLoader
